export default [
  {
    path: '/v2/downloads',
    name: 'v2-downloads',
    component: () => import('@/views/v2/downloads/V2Downloads.vue'),
    meta: {
      layout: 'v2',
      pageTitle: 'Downloads',
      resource: 'Profile',
      action: 'read',
    },
  },
  {
    path: '/v2/connections',
    name: 'v2-connections',
    component: () => import('@/views/v2/connections/V2Connections.vue'),
    meta: {
      layout: 'v2',
      pageTitle: 'My Retailers',
      resource: 'Wallet',
      action: 'read',
    },
  },
  {
    path: '/v2/orders',
    name: 'v2-orders',
    component: () => import('@/views/v2/orders/V2OrderList.vue'),
    meta: {
      layout: 'v2',
      pageTitle: 'Orders',
      resource: 'Order',
      action: 'read',
    },
  },
  {
    path: '/v2/order/:orderId',
    name: 'v2-order/detail',
    props: true,
    component: () => import('@/views/v2/orders/V2Order.vue'),
    meta: {
      layout: 'v2',
      pageTitle: 'Orders',
      resource: 'Order',
      action: 'read',
    },
  },
  // Wishlist / Selection
  {
    path: '/v2/selection',
    name: 'v2-selection',
    component: () => import('@/views/v2/wishlist/V2WishlistList.vue'),
    meta: {
      layout: 'v2',
      pageTitle: 'Wishlists',
      resource: 'Brand',
      action: 'read',
    },
  },
  {
    path: '/v2/wishlist',
    name: 'v2-wishlist',
    component: () => import('@/views/v2/wishlist/V2WishlistList.vue'),
    meta: {
      layout: 'v2',
      pageTitle: 'Wishlist',
      resource: 'Retailer',
      action: 'read',
    },
  },
  {
    path: '/v2/selection-products/:wishlistId',
    name: 'v2-selection-products',
    props: true,
    component: () => import('@/views/v2/wishlist/V2WishlistProducts.vue'),
    meta: {
      layout: 'v2',
      pageTitle: 'Wishlist Products',
      resource: 'Brand',
      action: 'read',
    },
  },
  {
    path: '/v2/wishlist-products/:wishlistId',
    name: 'v2-wishlist-products',
    props: true,
    component: () => import('@/views/v2/wishlist/V2WishlistProducts.vue'),
    meta: {
      layout: 'v2',
      pageTitle: 'Wishlist Products',
      resource: 'Retailer',
      action: 'read',
    },
  },
  {
    path: '/v2/wishlist/public/:publicToken',
    name: 'v2-wishlist-public',
    props: true,
    component: () => import('@/views/v2/wishlist/V2PublicWishlist.vue'),
    meta: {
      layout: 'v2',
      guest: true,
      pageTitle: 'Wishlist Products',
      resource: 'Brand',
      action: 'read',
    },
  },
  // Profile Preview Collections (read-only, used inside profile preview modal iframe)
  {
    path: '/v2/profile-preview-collections',
    name: 'v2-profile-preview-collections',
    component: () => import('@/views/v2/collection/V2ProfilePreviewCollections.vue'),
    meta: {
      layout: 'v2',
      pageTitle: 'Profile Preview Collections',
      resource: 'Brand',
      action: 'read',
    },
  },
  // Collections
  {
    path: '/v2/collections',
    name: 'v2-collections',
    component: () => import('@/views/v2/collection/V2CollectionList.vue'),
    meta: {
      layout: 'v2',
      pageTitle: 'Collections',
      resource: 'Brand',
      action: 'read',
    },
  },
  {
    path: '/v2/collections/edit/:id?',
    name: 'v2-collection/edit',
    component: () => import('@/views/v2/collection/V2CollectionEdit.vue'),
    meta: {
      layout: 'v2',
      pageTitle: 'Upload Collection',
      resource: 'Brand',
      action: 'read',
    },
  },
  {
    path: '/v2/collection-products/:collectionId',
    name: 'v2-collection/products',
    props: true,
    component: () => import('@/views/v2/collection/V2CollectionProducts.vue'),
    meta: {
      layout: 'v2',
      pageTitle: 'Collection Products',
      resource: 'Shop',
      action: 'read',
    },
  },
  // Shipments
  {
    path: '/v2/shipments',
    name: 'v2-shipments',
    component: () => import('@/views/v2/shipments/V2ShipmentList.vue'),
    meta: {
      layout: 'v2',
      pageTitle: 'Shipments',
      resource: 'Shipment',
      action: 'read',
    },
  },
  {
    path: '/v2/shipment/:shipmentId',
    name: 'v2-shipment/detail',
    component: () => import('@/views/v2/shipments/V2Shipment.vue'),
    meta: {
      layout: 'v2',
      pageTitle: 'Shipments',
      resource: 'Shipment',
      action: 'read',
    },
  },
  // Product Detail
  {
    path: '/v2/product/:id/c/:collectionId',
    name: 'v2-product-detail',
    component: () => import('@/views/v2/product/V2ProductDetails.vue'),
    meta: {
      layout: 'v2',
      pageTitle: 'Product Details',
      resource: 'Shop',
      action: 'read',
    },
  },
  {
    path: '/v2/product/:id/c/:collectionId/w/:wishlistId',
    name: 'v2-product-detail-with-wishlist',
    component: () => import('@/views/v2/product/V2ProductDetails.vue'),
    meta: {
      layout: 'v2',
      pageTitle: 'Product Details',
      resource: 'Shop',
      action: 'read',
    },
  },
  // Operations (Account Settings - Segmentation + Addresses)
  {
    path: '/v2/operations',
    name: 'v2-operations',
    component: () => import('@/views/v2/operations/V2Operations.vue'),
    meta: {
      layout: 'v2',
      pageTitle: 'Operations',
      resource: 'Profile',
      action: 'read',
    },
  },
  // Sales Analytics
  {
    path: '/v2/sales-analytics',
    name: 'v2-sales-analytics',
    component: () => import('@/views/v2/sales-analytics/V2SalesAnalytics.vue'),
    meta: {
      layout: 'v2',
      pageTitle: 'Sales Insights',
      resource: 'Brand',
      action: 'read',
    },
  },
  // Analytics (Makeke Dashboard)
  {
    path: '/v2/analytics',
    name: 'v2-analytics',
    component: () => import('@/views/v2/analytics/V2Analytics.vue'),
    meta: {
      layout: 'v2',
      pageTitle: 'Analytics',
      resource: 'Brand',
      action: 'read',
    },
  },
  // Retailer Profile
  {
    path: '/v2/profile',
    name: 'v2-profile',
    component: () => import('@/views/v2/retailer-profile/V2RetailerProfile.vue'),
    meta: {
      layout: 'v2',
      pageTitle: 'Profile',
      resource: 'Profile',
      action: 'read',
    },
  },
  // Manage Team (Account Settings - Additional Users)
  {
    path: '/v2/manage-team',
    name: 'v2-manage-team',
    component: () => import('@/views/v2/manage-team/V2ManageTeam.vue'),
    meta: {
      layout: 'v2',
      pageTitle: 'Manage Team',
      resource: 'Profile',
      action: 'read',
    },
  },
  {
    path: '/v2/checkout',
    name: 'v2-checkout',
    component: () => import('@/views/v2/checkout/V2RetailerCartPage.vue'),
    meta: {
      layout: 'v2',
      pageTitle: 'Carts',
      resource: 'Retailer',
      action: 'read',
    },
  },
  // Brand Detail (Retailer)
  {
    path: '/v2/brand/:brandId',
    name: 'v2-brand/detail',
    component: () => import('@/views/v2/brand/V2BrandDetail.vue'),
    meta: {
      layout: 'v2',
      pageTitle: 'Brand',
      resource: 'Profile',
      guestResource: 'Guest',
      action: 'read',
    },
  },
  // Retailer Dashboard (V2)
  {
    path: '/v2/dashboard',
    name: 'v2-dashboard',
    component: () => import('@/views/v2/dashboard/V2RetailerDashboard.vue'),
    meta: {
      layout: 'v2',
      pageTitle: 'Dashboard',
      breadcrumb: [{ text: 'Dashboard', active: true }],
      resource: 'Retailer',
      action: 'read',
    },
  },
]
